import { Dispatch, SetStateAction } from "react";
import { HStack } from "./HStack";
import { VStack } from "./VStack";
import { Checkbox } from "./Checkbox";

interface AgreementSectionProps {
  privateAgree: boolean;
  setPrivateAgree: Dispatch<SetStateAction<boolean>>;
  marketingAgree: boolean;
  setMarketingAgree: Dispatch<SetStateAction<boolean>>;
}

export function AgreementSection({
  privateAgree,
  setPrivateAgree,
  marketingAgree,
  setMarketingAgree,
}: AgreementSectionProps) {
  const allChecked = privateAgree && marketingAgree;

  return (
    <VStack width="100%" gap="8px" alignItems="flex-start">
      <Checkbox
        index="mkt-all"
        checked={allChecked}
        onChange={() => {
          const next = !allChecked;
          setPrivateAgree(next);
          setMarketingAgree(next);
        }}
        label="전체 동의"
      />
      <VStack gap="8px" width="100%" css={{ paddingLeft: "18px" }}>
        <HStack alignItems="center" justifyContent="space-between" width="100%">
          <HStack alignItems="center" gap="7px">
            <Checkbox
              index="mkt-private"
              checked={privateAgree}
              onChange={() => setPrivateAgree((prev) => !prev)}
            />
            <div className="label_2_r">개인정보 수집 및 이용 동의 (필수)</div>
          </HStack>
          <a
            className="caption_11_r"
            href="https://goifuneral.notion.site/146a79013e6c40a9b4731dd07a8ad99d"
            target="_blank"
            rel="noreferrer"
          >
            보기
          </a>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" width="100%">
          <HStack alignItems="center" gap="7px">
            <Checkbox
              index="mkt-marketing"
              checked={marketingAgree}
              onChange={() => setMarketingAgree((prev) => !prev)}
            />
            <div className="label_2_r">마케팅 정보 수신 동의 (선택)</div>
          </HStack>
          <a
            className="caption_11_r"
            href="https://goifuneral.notion.site/3d74caff865d48ccbf32d9a0ad3df80b"
            target="_blank"
            rel="noreferrer"
          >
            보기
          </a>
        </HStack>
      </VStack>
    </VStack>
  );
}
